import React from "react"
import styled from "styled-components"
import { Formik } from "formik"
import * as Yup from "yup"
import { toast } from "react-toastify"

import { useIntl, FormattedMessage } from "react-intl"
import * as spacings from "styles/spacing"
import { red } from "styles/colors"
import Button from "components/Button"
import Input from "components/Input"
import Toast from "components/Toast"

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-left: ${spacings.xxxLarge};
`

const FormContainer = styled.div`
  position: relative;
  display: flex;
  z-index: 10;
  margin-bottom: ${spacings.medium};
`

const Desc = styled.span`
  font-size: 12px;
  color: ${props => props.color};
`

const ButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`

const Send = styled.span`
  padding: 0 ${spacings.large};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`

const ValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email")
    .required("Email is required")
})

const EmailForm = () => {
  const intl = useIntl()

  return (
    <Formik
      initialValues={{ email: "" }}
      onSubmit={async (values, actions) => {
        await fetch("/.netlify/functions/sendEmail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: values.email,
            locale: intl.locale
          })
        }).then(response => {
          response.json()
          actions.resetForm()
        })

        toast(
          intl.formatMessage({
            id: "home.sent"
          })
        )
      }}
      validateOnChange={false}
      validationSchema={ValidationSchema}
    >
      {({
        values,
        handleSubmit,
        handleChange,
        handleBlur,
        errors,
        setErrors
      }) => (
        <Container>
          <FormContainer>
            <form onSubmit={handleSubmit}>
              <Input
                type="text"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                name="email"
                placeholder={intl.formatMessage({
                  id: "home.inputPlaceholder"
                })}
              />
              <ButtonContainer>
                <Button type="submit">
                  <Send>
                    {intl.formatMessage({
                      id: "home.send"
                    })}
                  </Send>
                </Button>
              </ButtonContainer>
            </form>
          </FormContainer>
          {errors.email ? (
            <Desc color={red}>{errors.email}</Desc>
          ) : (
            <Desc color="white">
              <FormattedMessage id="home.inputLabel" />
            </Desc>
          )}
          <Toast />
        </Container>
      )}
    </Formik>
  )
}

export default EmailForm
